import styled from 'styled-components';
import LocationIcon from '../../../../new-components/svg-icons/LocationIcon';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

interface CoverSectionProps {
  image: string;
  location: string;
}

const CoverSection = ({ image, location }: CoverSectionProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <Container>
      <ImageWrapper
        src={image ?? ''}
        alt=""
        width={isMobile ? 361 : 400}
        height={231}
        style={{
          borderRadius: '8px',
          objectFit: 'cover',
          height: '231px'
        }}
        imageSize="high"
        withSkeleton
      />

      <LocationChipContainer>
        <LocationIcon outline={true} />
        <span>{location}</span>
      </LocationChipContainer>
    </Container>
  );
};

const LocationChipContainer = styled.div`
  position: absolute;
  bottom: 12px;
  inset-inline-start: 12px;
  display: flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 360px;
  background-color: rgba(0, 0, 0, 0.5);

  span {
    font-size: 15px;
    color: #fff;
    font-weight: materialRegular;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    bottom: 10px;
    inset-inline-start: 16px;
    span {
      font-size: 11px;
    }
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 231px;
  overflow: hidden;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default CoverSection;
